import React, { useEffect, useState } from 'react'
import AppBreadcrumb from '../../Shared/AppBreadcrumb'
import FecthingSpinner from '../../Shared/FecthingSpinner'
import httpService from "../../../services/http.service";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import {
    extractResponseValidationErrors,
    formatCash, formatNumber, getUserFullName, numberWithSeparator,
    PERIODICITY_DAILY,
    PERIODICITY_MONTHLY,
    PERIODICITY_WEEKLY,
    PERIODICITY_YEARLY
} from "../../../utils/index";
import moment from 'moment/moment';
import { Badge, Col, Form, FormGroup } from "reactstrap";
import { useFormik } from 'formik';
import * as Yup from "yup";
import useAlert from '../../../hooks/useAlert';
import { serialize } from 'object-to-formdata';
import AppAlert from '../../Shared/AppAlert';
import AppInput from '../../Shared/AppInput';

const Challenge = ({ history, location, match, ...props }) => {

    const [data, setData] = useState([])
    const [search, setSearch] = useState('')
    const [fetching, setFetching] = useState(false)
    const [searching, setSearching] = useState(false)

    const navigateToOpinion = (data) => {
        history.push(`/opinions/${data.sond_id}`);
    }

    useEffect(() => {
      fetchData()
    }, [])
    

    const fetchData = async (params = {}, cb = () => null) => {
        try {
            setSearching(true)
            const { data: response } = await httpService.post(`/challenge/opinions`, { search });
            console.log("Response search challenge:", response)
            setSearch(response.search);
            setData(response.data);
            cb();
            setSearching(false)
        } catch (error) {
            console.error('error search challenge:', error);
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();
        fetchData()
    };


    return (
        <div className="container-fluid">
            <AppBreadcrumb title="Challenges" />
            {fetching ?
                <FecthingSpinner />
                :
                <div>
                    <div className="card border shadow-sm">
                        <form onSubmit={onSubmit}>
                            <div className="card-header bg-info text-white font-weight-bold">
                                <i className="fa fa-search"></i>{' '}
                                <span>Filtre de recherche</span>
                            </div>
                            <div className="card-body">
                                <div className="row h-">
                                    <div className="col-md-5">
                                        <AppInput
                                            name="user_id"
                                            placeholder="#Recherche..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-5">
                                        <button type="submit" className="btn btn-success">
                                            <i className="fa fa-check"></i>{' '}
                                            <span className="font-weight-bold">Rechercher</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    {searching ?
                        <FecthingSpinner />
                        : data.length === 0 ?
                            <div className='card'>
                                <div className="card-body">
                                    <h5 className='text-center text-muted mt-1'>Aucun resultat</h5>
                                </div>
                            </div>
                            :
                            <div className="row clearfix">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="font-weight-normal"><h5>Top 10 des utilisateurs {process.env.REACT_APP_APP_NAME} du challenge <b className='text-success'>{search}</b></h5></div>
                                        <div className="table-responsive">
                                            <table className="table table-hover table-custom spacing8">
                                                <thead>
                                                    <tr>
                                                        <th>Photo</th>
                                                        <th>Utilisateur</th>
                                                        <th>opinion</th>
                                                        <th>Vues</th>
                                                        <th>Commentaires</th>
                                                        <th>Likes</th>
                                                        <th>Partages</th>
                                                        <th>Dernière activité</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.map((obj, index) => (
                                                        <tr key={index} onClick={() => navigateToOpinion(obj)} style={{ cursor: "pointer" }}>
                                                            <td className="w60">
                                                                <img
                                                                    src={obj?.prof_picture || MyOpinionLogo}
                                                                    data-toggle="tooltip"
                                                                    data-placement="top" alt={`@(${obj?.user_username})`}
                                                                    className="w35 rounded"
                                                                    style={{ objectFit: 'cover' }}
                                                                />
                                                            </td>
                                                            <td>
                                                                {getUserFullName(obj, true)}{' '}
                                                                {obj.user_verified && (
                                                                    <i style={{ cursor: 'pointer' }} title="Verified" className="fa fa-check-circle-o text-primary mr-1" />
                                                                )}
                                                                {obj.user_gold && (
                                                                    <i style={{ cursor: 'pointer' }} title="Premium / Gold" className="fa fa-star text-warning mr-1" />
                                                                )}
                                                            </td>
                                                            <td>
                                                                {obj.sond_caption.length > 50 ? `${obj.sond_caption?.slice(0, 50)}...` : obj.sond_caption}
                                                            </td>
                                                            <td className='text-success font-weight-bold'>
                                                                {formatCash(Number(obj?.sond_views)?.toFixed(0))}
                                                            </td>
                                                            <td className='text-center'>
                                                                {formatCash(obj?.comments_count)}
                                                            </td>
                                                            <td>
                                                                {formatCash(obj?.soutiens_count)}
                                                            </td>
                                                            <td>
                                                                {formatCash(obj?.shares_count)}
                                                            </td>
                                                            <td>
                                                                {moment(obj?.sond_created_at).format('DD/MM/YYYY HH:mm')}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            }
        </div>
    )
}

export default Challenge